// frontend/src/pages/InvoiceForm.tsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { InvoiceApi, PartnerApi } from "../lib/api";

export default function InvoiceForm() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const { data: partners } = useQuery({ queryKey: ["partners"], queryFn: () => PartnerApi.list() });
  const [form, setForm] = useState({ name: "", partnerId: "", invoiceDate: new Date().toISOString().split("T")[0] });

  const mut = useMutation({
    mutationFn: () => InvoiceApi.create({ name: form.name, partnerId: parseInt(form.partnerId), invoiceDate: form.invoiceDate, type: "out_invoice" }),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ["invoices"] }); navigate("/invoices"); },
  });

  return (
    <div className="max-w-lg mx-auto">
      <h1 className="text-2xl font-bold mb-6">New Invoice</h1>
      <form onSubmit={(e) => { e.preventDefault(); mut.mutate(); }} className="bg-white rounded-xl shadow-sm border p-6 space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Invoice Number *</label>
          <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="w-full border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500" required />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Customer *</label>
          <select value={form.partnerId} onChange={(e) => setForm({ ...form, partnerId: e.target.value })}
            className="w-full border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500" required>
            <option value="">Select...</option>
            {partners?.map((p: any) => <option key={p.id} value={p.id}>{p.name}</option>)}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Invoice Date</label>
          <input type="date" value={form.invoiceDate} onChange={(e) => setForm({ ...form, invoiceDate: e.target.value })}
            className="w-full border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500" />
        </div>
        <div className="flex gap-3 pt-2">
          <button type="submit" disabled={mut.isPending}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50">
            {mut.isPending ? "Saving..." : "Create Invoice"}
          </button>
          <button type="button" onClick={() => navigate("/invoices")}
            className="px-6 py-2 border rounded-lg hover:bg-gray-50">Cancel</button>
        </div>
      </form>
    </div>
  );
}
